const ACTION_TYPES = {
    SHOW_SUPER_CHAT: 'SHOW_SUPER_CHAT',
    SUPER_CHAT_CONFIG: 'SUPER_CHAT_CONFIG',
    CLOSE_SUPER_CHAT: 'CLOSE_SUPER_CHAT',
    SET_REQUEST_IN_FLIGHT: 'SET_REQUEST_IN_FLIGHT',
    SET_CONTEXT_PROMPTS: 'SET_CONTEXT_PROMPTS',
    SET_WELCOME_MAT_SHOWN: 'SET_WELCOME_MAT_SHOWN',
    SET_COMPLEMENTARY_CAROUSEL: 'SET_COMPLEMENTARY_CAROUSEL',
    CLEAR_COMPLEMENTARY_CAROUSELS: 'CLEAR_COMPLEMENTARY_CAROUSELS',
    SET_CHAT_PAUSED: 'SET_CHAT_PAUSED'
};

const initialState = {
    showSuperChat: false,
    productInfo: null,
    entryPointData: null,
    prompts: [],
    contextPrompts: [],
    config: {},
    isRequestInFlight: false,
    welcomeMatShownThisSession: false,
    complementaryCarousels: {},
    isChatPaused: false
};

const reducer = function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case ACTION_TYPES.SHOW_SUPER_CHAT: {
            return {
                ...state,
                showSuperChat: payload.showSuperChat,
                prompts: payload.prompts,
                entryPointData: payload.entryPointData
            };
        }
        case ACTION_TYPES.SUPER_CHAT_CONFIG: {
            return {
                ...state,
                config: payload
            };
        }
        case ACTION_TYPES.CLOSE_SUPER_CHAT: {
            return {
                ...state,
                showSuperChat: false,
                prompts: [],
                entryPointData: null,
                isRequestInFlight: false,
                complementaryCarousels: {},
                isChatPaused: false
            };
        }
        case ACTION_TYPES.SET_CHAT_PAUSED: {
            return {
                ...state,
                isChatPaused: payload
            };
        }
        case ACTION_TYPES.SET_COMPLEMENTARY_CAROUSEL: {
            const { sourceProductId, header, products } = payload;

            return {
                ...state,
                complementaryCarousels: {
                    ...state.complementaryCarousels,
                    [sourceProductId]: {
                        sourceProductId,
                        header,
                        products
                    }
                }
            };
        }
        case ACTION_TYPES.CLEAR_COMPLEMENTARY_CAROUSELS: {
            return {
                ...state,
                complementaryCarousels: {}
            };
        }
        case ACTION_TYPES.SET_REQUEST_IN_FLIGHT: {
            return {
                ...state,
                isRequestInFlight: payload
            };
        }
        case ACTION_TYPES.SET_CONTEXT_PROMPTS: {
            return {
                ...state,
                contextPrompts: payload
            };
        }
        case ACTION_TYPES.SET_WELCOME_MAT_SHOWN: {
            return {
                ...state,
                welcomeMatShownThisSession: payload
            };
        }

        default: {
            return state;
        }
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

export default reducer;
